import { render } from "./Individual.vue?vue&type=template&id=9cbbebf0&scoped=true"
import script from "./Individual.vue?vue&type=script&lang=js"
export * from "./Individual.vue?vue&type=script&lang=js"

import "./Individual.vue?vue&type=style&index=0&id=9cbbebf0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-9cbbebf0"

export default script